import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl_SPB } from "../../BaseUrl";
import { useAuth } from "../../AuthProvider";

export default function StripeReturnPage() {

  const [status, setStatus] = useState(null);
  const authContext = useAuth();

  const headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + authContext.token
  };

  const refreshAndLoad = async () => {
    try {

      // 1. refresh account from Stripe
      await axios.post(
        `${baseUrl_SPB}/api/v1/stripe/refresh`,
        {},
        { headers }
      );

      // 2. fetch updated status
      const res = await axios.get(
        `${baseUrl_SPB}/api/v1/stripe/status`,
        { headers }
      );

      setStatus(res.data);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    refreshAndLoad();
  }, []);

  return (
    <div style={{ padding: 20 }}>

      <h2>Payment Setup Status</h2>

      {!status && <p>Checking Stripe account...</p>}

      {status && (
        <div>

          <p>Charges Enabled: {status.chargesEnabled ? "✅" : "❌"}</p>
          <p>Payouts Enabled: {status.payoutsEnabled ? "✅" : "❌"}</p>
          <p>Details Submitted: {status.detailsSubmitted ? "✅" : "❌"}</p>

          <h3>
            {status.onboardingComplete
              ? "🎉 You're ready to accept payments"
              : "⚠️ Setup incomplete"}
          </h3>

        </div>
      )}

    </div>
  );
}